import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=d4b77230&scoped=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=js"
export * from "./SocialNetworks.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworks.vue?vue&type=style&index=0&id=d4b77230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b77230",
  null
  
)

export default component.exports